import { render, staticRenderFns } from "./btn-doc-download.vue?vue&type=template&id=b584bfac&scoped=true&"
import script from "./btn-doc-download.vue?vue&type=script&lang=js&"
export * from "./btn-doc-download.vue?vue&type=script&lang=js&"
import style0 from "./btn-doc-download.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b584bfac",
  null
  
)

export default component.exports